<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 class="font-size--24" style="word-break: keep-all">
        펀다에이아이 집금 서비스 신청을 위해<br />
        필요한 자료들을 체크하고 있습니다.<br />
      </h1>
      <h3 class="font-size--18 mt-10" style="word-break: keep-all">
        * 카드사 변경까지 모두 끝난 경우에만 신청이 시작됩니다. <br />
      </h3>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { commaFormat } from '@/filter/number'
import { locationRedirect } from '@/util'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  data() {
    return {
      requestLoanLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('document', ['fileObj']),
    ...mapState('contract', ['limitTransaction']),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'investingBnplInsur',
      'investing',
      'getOffer',
    ]),
    ...mapGetters('evaluation', ['isExpire']),
    offer() {
      return this.getOffer
    },
  },
  watch: {
    offer: {
      immediate: true,
      deep: true,
      handler(newOffer) {
        console.log('Offer updated:', newOffer)
      },
    },
    me: {
      deep: true,
      immediate: true,
      async handler() {},
    },
  },
  async created() {
    _meta({
      titles: ['펀다에이아이 집금 서비스 신청'],
    })

    // Ensure offer data exists in store when entering this page directly
    const offerUuid = this.$route.query.offer?.uuid
    if (offerUuid) {
      try {
        const { data } = await defaultApi.getLoanOffer(offerUuid)
        await this.updateOffer(data)
      } catch (error) {
        console.error('Offer 정보를 가져오는 데 실패했습니다:', error)
        await this.$swal.basic.alert('대출정보를 불러오지 못했습니다. 다시 시도해주세요.')
        return
      }
    }

    await this.validateUserRequirements2()
    await this.createLoanAndGoInvesting()
  },

  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    ...mapActions('loan', [
      'addLoansOffersCurrent',
      'createLoan',
      'getLoansByOngoing',
      'getLoanAvailableTime',
      'updateOffer',
    ]),
    ...mapActions('evaluation', [
      'addCreditEvaluations',
      'isKcsAgreements',
      'isHometaxAccounts',
      'getCreditEvaluationsCurrent',
    ]),
    ...mapActions('kyc', ['addCdd', 'getMobileAuthUrl']),
    ...mapActions('document', ['getDocuments']),
    ...mapActions('contract', ['getLimitTransaction', 'checkExistContract', 'getCurrent']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),

    async validateUserRequirements2() {
      // 본인인증 체크
      if (!this.me) {
        await this.getMe()
      }
      console.log('********* 본인인증 체크', this.me)
      if (!this.me.kyc.mobileVerificationIsDone) {
        const redirect = await this.getMobileAuthUrl({
          redirectPage: `${location.origin}/kyc/verify-id?from=funda-bnpl-insur`,
        })
        return locationRedirect(redirect)
      }

      console.log('********* 신분증 체크')
      // 신분증 인증 체크
      if (!this.fileObj) {
        await this.getDocuments()
      }
      if (!this.me.kyc.idCardVerificationIsDone) {
        return this.$router.replace({
          path: '/kyc/verify-id-card',
          query: { next: '/loan/funda-bnpl-insur-check' },
        })
      }

      console.log('********* 주거래은행 체크')
      // 주거래은행 체크
      if (!this.me.withdrawalAccount.accountNumber || !this.me.kyc.bankVerificationIsDone) {
        return this.$router.replace({
          path: '/signup/bank/withdrawal',
          query: { next: '/loan/funda-bnpl-insur-check' },
        })
      }

      // 사업자등록증 체크
      console.log('********* 사업자등록증 체크', this.fileObj.businessLicense)
      if (!this.fileObj.businessLicense) {
        return this.$router.replace({
          path: '/signup/documents',
          query: { next: '/loan/funda-bnpl-insur-check' },
        })
      }

      // 집금계좌 체크
      console.log('********* 집금계좌 체크', this.me?.collectionAccount)
      if (!this.me?.collectionAccount?.accountNumber) {
        return this.$router.replace({
          path: '/bank/collections',
          query: { next: '/loan/funda-bnpl-insur-check' },
        })
      }

      // 소득증명 체크
      console.log('********* 소득증명 체크', this.fileObj?.certificateOfIncomeAmount)
      if (!this.fileObj?.certificateOfIncomeAmount) {
        return this.$router.replace({
          path: '/signup/certification',
          query: { next: '/loan/funda-bnpl-insur-check' },
        })
      }
    },
    commaFormat,
    async createLoanAndGoInvesting() {
      if (this.requestLoanLoading) return
      try {
        this.requestLoanLoading = true

        // 신용인증 유효기간 만료면 신용인증으로
        if (this.isExpire) {
          const { isConfirmed } = await this.$swal.basic.confirm({
            html: '신용 인증 유효기간이 만료되어,<br> 신용 인증 페이지로 이동합니다',
          })
          if (!isConfirmed) {
            return
          }

          await this.addCreditEvaluations({
            redirectPath: `${this.$route.path}`,
          })
          return
        }

        console.log('!!!!!!!!!대출 신청 직전')

        // 대출 불가면 알림
        if (this.me.isLoanable !== true) {
          await this.$swal.basic.alert({
            html: '대출신청을 할 수 없습니다. 고객센터로 문의 주세요.',
          })
          return
        }

        // 론 생성 후 모집 페이지로 이동
        await this.createLoan(this.offer)
        await this.getLoansByOngoing()
        await this.$router.replace(`/loan/${this.investingBnplInsur.uuid}/investing`)
      } finally {
        this.requestLoanLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>

